module.exports = __webpack_public_path__ + "static/flags/MO-48c88f8f6658163c247a10a71d07c776.gif";